
import netteForms from 'nette-forms';
window.Nette = netteForms;

// Json
Nette.validators['AppFormsValidator_validateJson'] = (elem, args, val) => {
	try {
		JSON.parse(val);
	}
	catch(err) {
		return false;
	}

	return true;
};

Nette.validators['AppFormsValidator_validateJsonMaxLength'] = (elem, args, val) => {
	return val.length <= args;
};

// Wysiwyg
if (typeof tinymce === 'object') {
	$("textarea[data-type=\"text:wysiwyg\"]").each(function () {
		const $textArea = $(this);
		const baseConfig = {
			selector: '#' + $textArea.attr('id'),
			language: document.getElementsByTagName('html')[0].getAttribute('lang'),
			menubar: false,
			plugins: "link code lists textcolor",
			toolbar: "undo redo | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link removeformat code",
			extended_valid_elements: "span[style],p[style],strong[style],em[style],a[style]",
			setup: function (editor) {
				editor.on('change', function () {
					document.getElementById(editor.id).value = editor.getContent();
				});
				editor.on('NodeChange', function (e) {
					if (e && e.element && e.element.nodeName === 'IMG' && !e.element.hasAttribute('data-custom-size')) {
						var img = e.element;
						var tmpImg = new Image();
						tmpImg.onload = function() {
							if (tmpImg.naturalWidth > tmpImg.naturalHeight) {
								img.setAttribute('width', 512);
							} else {
								img.setAttribute('width', 236);
							}
							img.setAttribute('data-custom-size', '1');
							editor.save();
						};
						tmpImg.src = img.src;
					}
				});
			}
		};

		if ($textArea.attr('data-ajax-image-upload') !== undefined) {
			baseConfig.plugins   += " image";
			baseConfig.toolbar   += " | image";

			baseConfig.images_upload_url = $textArea.data('ajax-image-upload');

			baseConfig.relative_urls     = false;
			baseConfig.automatic_uploads = true;

			baseConfig.image_class_list  = $textArea.data('image-class-list') || [];

			baseConfig.image_dimensions  = false;
			baseConfig.images_file_types = 'jpeg,jpg,png,webp';
			baseConfig.object_resizing   = false;
		}

		tinymce.init(baseConfig);
	});
}

// Image preview
if (typeof $ === 'function') {
	$('label.file-preview').each(function () {
		var $filePreview = $(this);
		$('#' + $filePreview.attr('for')).change(function (event) {
			var $image, $span, spantext, file;
			$image = $filePreview.find('img');
			if ($image.length === 0) {
				$image = $('<img>');
				$filePreview.append($image);
			}
			if (event.target.files.length > 0) {
				$filePreview.find('source').remove();
				file = new File([event.target.files[0]], event.target.files[0].name);
				$image.attr('src', URL.createObjectURL(file));
			}
			else { $image.remove(); }
			$span = $filePreview.find('span');
			spantext = $span.html();
			$span.remove();
			$filePreview.append('<span> ' + spantext + '</span>');
		});
	});
}

// Default datetime picker
if (typeof $ === 'function' && typeof $.datetimepicker === 'object') {
	$.datetimepicker.setLocale($('html').attr('lang'));

	$('input[data-type=\"datetime\"]').datetimepicker({
		format:     'Y-m-d H:i',
		formatDate: 'Y-m-d',
	});
}
